import { getRoleString } from "@vehicle-contract/common/lib/model/contract/Role";
import { useLocation } from "react-router";
import { ContractToken, useContractToken } from "../contract/ContractParams";
import {
  PaymentViewModel,
  SalesContractReferenceViewModel,
} from "../payments/PaymentViewModel";
import StaticRoutes from "../static-pages/StaticRoutes";

export function createBecomeMemberPath(
  returnTo?: string,
  reportToken?: ContractToken
) {
  const params = new URLSearchParams();
  if (returnTo) params.set("returnTo", returnTo);
  if (reportToken) {
    params.set("token", reportToken.value);
    params.set("role", getRoleString(reportToken.role));
  }
  return `${StaticRoutes.becomeMember.path}?${params.toString()}`;
}

export function useBecomeMemberPath() {
  const location = useLocation();
  const token = useContractToken();
  return createBecomeMemberPath(location.pathname, token || undefined);
}

export interface ReturnPathParameters {
  returnPath: string;
  contractToken?: ContractToken;
}

export function createReturnPath(
  parameters: ReturnPathParameters | SalesContractReferenceViewModel
) {
  const tokenValue =
    "token" in parameters
      ? parameters.token
      : parameters.contractToken
      ? parameters.contractToken.value
      : null;
  const returnPath = parameters.returnPath;
  return tokenValue ? `${returnPath}?token=${tokenValue}` : returnPath;
}

export function getMembershipPaymentPath(payment: PaymentViewModel) {
  return StaticRoutes.membershipPayment.path
    .replace(":customerGuid", payment.paymentDetails.customerGuid)
    .replace(":paymentId", payment.paymentDetails.id);
}
